import styled from 'styled-components';

export const FormHeader = styled.h3`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 35px;
  line-height: 36px;
  font-weight: ${props => props.theme.fontWeightBlack};
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.theme.bodyColor};
  margin: 0;
`;

export const Desc = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 17px;
  line-height: 20px;
  font-weight: ${props => props.theme.fontWeightBold};
  text-align: center;
  color: ${props => props.theme.bodyColor};
`;

export const SmallDesc = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 14px;
  line-height: 15px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-align: center;
  color: ${props => props.theme.bodyColor};
`;

export const HelpBlock = styled.label`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 13px;
  line-height: 1.5;
  color: ${props => props.theme.errorColor};
  margin-top: 5px;
  max-width: 320px;

  /* do not mistaken this as the data-error="show" on the input field */
  &[data-error="show"] {
    display: block !important;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.secondaryColor30Transparent};
  background-color: ${props => props.theme.secondaryColorLight};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 13px;
  line-height: 13px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-align: left;
  color: ${props => props.theme.secondaryColor};
  padding-left: 20px;

  &&:focus, &&:not(:placeholder-shown) {
    color: ${props => props.theme.bodyColor};
    background-color: white;
  }

  &&::placeholder {
    color: ${props => props.theme.secondaryColor};
    text-transform: capitalize;
  }

  &[data-error="show"] {
    border-color: ${props => props.theme.errorColor};
  }

  &:not([data-error="show"]) + ${HelpBlock} {
    display: none;
  }
`;

export const SPassword = styled(TextInput)`
  && + span.icon-lw {
    display: block;
    position: relative;
    top: -72%;
    right: -85%;
    color: ${props => props.theme.secondaryColor};
  }

  && + span.icon-lw:hover {
    color: ${props => props.theme.bodyColor};
  }

  && + span.icon-lw + ${HelpBlock} {
    display: block;
    margin-top: -20px;
  }

  &&:not([data-error="show"]) + span.icon-lw + ${HelpBlock} {
    display: none;
  }
`;

export const Hint = styled.label`
  display: block;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 13px;
  line-height: 13px;
  color: ${props => props.theme.bodyColor};
  margin-top: -18px;
  max-width: 320px;
  width: 100%;
`;

export const InputContainer = styled.div`
  width: 100%;
  max-width: 320px;
  height: 40px;
  margin: 20px 0 0 0;

  & > .loading-panel-button {
    margin-top: 10px;
    width: 100%;

    .loading-panel-content {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  max-width: 320px;
  height: 40px;
  border-radius: 4px;
  background-color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 16px;
  line-height: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-align: center;
  text-transform: uppercase;
  color: white;
`;

export const Page = styled.div`
  display: flex;
  ${props => (props.theme.isXLarge ? `
    overflow: hidden;
  ` : `
    flex-direction: column-reverse;
    align-item: center;
  `)}
  ${props => props.theme.isMobile && `
    overflow-x: hidden;
  `}
`;
